import BasePolicy from '@/policies/BasePolicy.js';

export default class DiscussionReplyPolicy extends BasePolicy {
    viewAny(user, course) {
        if (user.isStudentSupportOfCourse(course.id)) {
            return false;
        }

        return (
            user.hasPermissionViaCourseTo(course, 'view discussion replies') ||
            user.hasGroupPermissionWithinCourse(course, 'view discussion replies')
        );
    }

    view(user, discussionReply, course) {
        return (
            discussionReply.user_id === user.id ||
            user.hasPermissionViaCourseTo(course, 'view discussion replies') ||
            user.hasGroupPermissionWithinCourse(course, 'view discussion replies')
        );
    }

    create(user, course) {
        return (
            user.hasPermissionViaCourseTo(course, 'create discussion replies') ||
            user.hasGroupPermissionWithinCourse(course, 'create discussion replies')
        );
    }

    update(user, discussionReply, course) {
        return (
            user.id === discussionReply.user_id &&
            (user.hasPermissionViaCourseTo(course, 'edit discussion replies') ||
                user.hasGroupPermissionWithinCourse(course, 'edit discussion replies'))
        );
    }

    delete(user, discussionReply, course) {
        return (
            user.id === discussionReply.user_id &&
            (user.hasPermissionViaCourseTo(course, 'delete discussion replies') ||
                user.hasGroupPermissionWithinCourse(course, 'delete discussion replies'))
        );
    }
}
